<template>
  <div>
    <h1 class="text-h3 mb-4">
      {{ $t('report.listTitle') }}
    </h1>
    <AddDialog v-model="dialog"></AddDialog>
    <v-btn class="my-4" @click="onClickNew"><v-icon>mdi-plus</v-icon>{{ $t('button.new') }}</v-btn>
    <template>
      <v-tabs v-model="tab">
        <v-tab
          v-for="service in serviceList"
          :key="service.id"
          :disabled="service.disabled"
        >
          {{ service.name }}
        </v-tab>
      </v-tabs>
    </template>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="service in serviceList" :key="service.id">
        <v-card
          class="d-flex align-center justify-center pa-4 mx-auto mb-4"
          max-width="100%"
          outlined
        >
          <div :class="`text-caption`">
            {{ service.description }}
          </div>
        </v-card>
        <component :is="service.component"></component>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import AddDialog from "@/components/service/AddDialog";
import C3List from "@/components/service/C3List";
import C31List from "@/components/service/C31List";
import C5List from "@/components/service/C5List";
export default {
  data() {
    return {
      dialog: false,
      tab: null,
    };
  },
  computed: {
    serviceList() {
      return [
        {
          id: 1,
          name: this.$t("report.serviceType.diagnostic_suggestion.title"),
          description: this.$t("report.serviceType.diagnostic_suggestion.description"),
          component: "C3List",
          disabled: false
        },
        {
          id: 3,
          name: this.$t("report.serviceType.quality_control.title"),
          description: this.$t("report.serviceType.quality_control.description"),
          component: "C5List",
          disabled: true
        }
      ];
    },
  },
  methods: {
    onClickNew() {
      this.dialog = true;
    }
  },
  components: {
    C3List,
    C31List,
    C5List,
    AddDialog
  }
};
</script>
<style scoped></style>
